export const ROLE_ALL = 'all';
export const ROLE_VEHICLE_MONITORING = 'vehicle_monitoring';

export enum ERole {
    SuperAdmin = 'super_admin',
    Driver = 'driver',
    Operator = 'operator',
    AdminGgm = 'admin_ggm',
}
